import type { JSX } from 'react'

import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { AppTitle } from '~/shared/ui/components/AppTitle'

export function Title(): JSX.Element {
  return <AppTitle t='content_settings' />
}

const skin = era.skin('routes/settings/content-settings')

ContentSettingsSubPage.displayName = 'ContentSettingsSubPage'
export function ContentSettingsSubPage(): JSX.Element {
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper>
        <ui.RenderSkin name='contentSettingsSubPageSkin' />
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
